<%# Broadcast handles the removal - nothing needed here %>
